import { graphql } from '@/generated/gql';

export const NEGOTIATION_TERMS_WIDGET_QUERY = graphql(/* GraphQL */ `
  query NegotiationTerms($id: UUID!) {
    tesseract {
      negotiationCase(id: $id) {
        id
        status
        processStatus
        supplier {
          id
          internalId
        }
        lowerDiscountBoundary
        upperDiscountBoundary
        strategy {
          id
          useHistoricTenderData
          useHistoricNegotiationData
          boundaryRules {
            id
            base
            lower
            upper
            sequence
          }
        }
        options {
          id
          initiatedBy
          quoteMode
          negotiationMode
          supplierInteractionMode
          negotiationObjective
        }
        demand {
          id
        }
        negotiatedQuote {
          id
          currency
          discount
          totalValue
          totalDiscountedValue
          totalPriceDiscount
          createdAt
        }
      }
    }
  }
`);
